window.CustomGalleryLightbox = window.CustomGalleryLightbox || {};

(function () {
  var imageCache = window.CustomGalleryLightbox._imageCache || new Map();
  window.CustomGalleryLightbox._imageCache = imageCache;

  function normalizeUrl(src) {
    if (!src) return '';
    try {
      return new URL(src, window.location.href).href;
    } catch (error) {
      return src;
    }
  }

  function preloadImage(src) {
    var url = normalizeUrl(src);
    if (!url) return Promise.resolve(false);

    if (imageCache.has(url)) {
      return imageCache.get(url);
    }

    var promise = new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';

      img.onload = function () {
        if (typeof img.decode === 'function') {
          img.decode().then(function () {
            resolve(true);
          }).catch(function () {
            resolve(true);
          });
        } else {
          resolve(true);
        }
      };

      img.onerror = function () {
        imageCache.delete(url);
        resolve(false);
      };

      img.src = url;
    });

    imageCache.set(url, promise);
    return promise;
  }

  function setScrollLock(locked) {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  function getImageSource(image) {
    if (!image) return '';

    return (
      image.currentSrc ||
      image.getAttribute('src') ||
      image.getAttribute('data-src') ||
      ''
    );
  }

  function getLoadedImageSource(image) {
    if (!image || !image.complete || image.naturalWidth <= 0) {
      return '';
    }

    return image.currentSrc || image.src || '';
  }

  function getTriggerThumbnail(trigger) {
    if (!trigger) return '';

    var image = trigger.querySelector('img');

    if (!image) {
      var card = trigger.closest('.custom-gallery-card');
      image = card ? card.querySelector('img') : null;
    }

    return getLoadedImageSource(image);
  }

  function setImageSource(image, src, alt) {
    if (!image) return;

    image.alt = alt || '';

    if (src) {
      image.src = src;
    } else {
      image.removeAttribute('src');
    }
  }

  // Simple lightbox
  window.CustomGalleryLightbox.initSimple = function (sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    if (section.dataset.customGallerySimpleReady === 'true') return;

    var lightbox = section.querySelector('[data-gallery-simple-lightbox]');
    var lightboxImage = section.querySelector('[data-gallery-simple-image]');
    var closeButton = section.querySelector('[data-gallery-simple-close]');
    var triggers = section.querySelectorAll('[data-gallery-simple-trigger]');

    if (!lightbox || !lightboxImage || !closeButton || !triggers.length) return;

    section.dataset.customGallerySimpleReady = 'true';

    var simpleToken = 0;
    var simpleCloseTimer = null;

    function openLightbox(src, alt, thumbnail) {
      if (!src) return;

      var currentToken = ++simpleToken;
      var previewSrc = thumbnail || src;

      window.clearTimeout(simpleCloseTimer);

      lightbox.classList.add('is-loading');
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');

      setScrollLock(true);

      // Show available preview immediately
      setImageSource(lightboxImage, previewSrc, alt);

      // Replace preview only after HD image is ready
      preloadImage(src).then(function (success) {
        if (currentToken !== simpleToken) return;
        if (!lightbox.classList.contains('is-active')) return;

        if (success) {
          lightboxImage.src = src;
        }

        requestAnimationFrame(function () {
          if (currentToken !== simpleToken) return;
          lightbox.classList.remove('is-loading');
        });
      });
    }

    function closeLightbox() {
      simpleToken++;

      lightbox.classList.remove('is-active');
      lightbox.classList.remove('is-loading');
      lightbox.setAttribute('aria-hidden', 'true');

      setScrollLock(false);

      window.clearTimeout(simpleCloseTimer);

      simpleCloseTimer = window.setTimeout(function () {
        if (!lightbox.classList.contains('is-active')) {
          lightboxImage.removeAttribute('src');
          lightboxImage.alt = '';
        }
      }, 240);
    }

    triggers.forEach(function (trigger) {
      function preload() {
        preloadImage(trigger.getAttribute('data-lightbox-src'));
      }

      trigger.addEventListener('pointerenter', preload);
      trigger.addEventListener('focus', preload);
      trigger.addEventListener('touchstart', preload, { passive: true });

      trigger.addEventListener('click', function () {
        openLightbox(
          trigger.getAttribute('data-lightbox-src'),
          trigger.getAttribute('data-lightbox-alt'),
          getTriggerThumbnail(trigger)
        );
      });
    });

    closeButton.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-active')) {
        closeLightbox();
      }
    });
  };

  // Flip lightbox
  window.CustomGalleryLightbox.initFlip = function (sectionId, lightboxId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    if (section.dataset.customGalleryFlipReady === 'true') return;

    var lightbox = document.getElementById(lightboxId);
    if (!lightbox) return;

    var lightboxTitle = lightbox.querySelector('[data-gallery-flip-title]');
    var lightboxOpen = lightbox.querySelector('[data-gallery-flip-open]');
    var closeButton = lightbox.querySelector('[data-gallery-flip-close]');
    var lightboxFlip = lightbox.querySelector('[data-gallery-flip-button]');
    var lightboxFrontImage = lightbox.querySelector('[data-gallery-flip-front]');
    var lightboxBackImage = lightbox.querySelector('[data-gallery-flip-back]');

    if (!lightboxFlip || !lightboxFrontImage || !lightboxBackImage) return;

    section.dataset.customGalleryFlipReady = 'true';

    var flipToken = 0;
    var closeTimer = null;

    function getCardImages(trigger) {
      var card = trigger.closest('.custom-gallery-card') || trigger;
      var images = Array.from(card.querySelectorAll('img')).filter(function (img) {
        return img.complete && img.naturalWidth > 0;
      });

      return {
        front: images[1] || images[0] || null,
        back: images[0] || null
      };
    }

    function createImagePlaceholder(sourceImage, targetImage) {
      if (!sourceImage || !targetImage) return null;

      var placeholder = sourceImage.cloneNode(true);

      placeholder.removeAttribute('srcset');
      placeholder.removeAttribute('sizes');
      placeholder.removeAttribute('loading');
      placeholder.src = sourceImage.currentSrc || sourceImage.src;

      placeholder.className = targetImage.className;
      placeholder.style.position = 'absolute';
      placeholder.style.inset = '0';
      placeholder.style.width = '100%';
      placeholder.style.height = '100%';
      placeholder.style.objectFit = 'contain';
      placeholder.style.pointerEvents = 'none';
      placeholder.style.zIndex = '2';

      targetImage.style.visibility = 'hidden';
      targetImage.parentElement.appendChild(placeholder);

      return placeholder;
    }
    function resetFlipState() {
      lightboxFlip.classList.remove('is-flipped');
      lightboxFlip.classList.remove('is-pointer-out');
      lightboxFlip.setAttribute('aria-pressed', 'false');
      lightbox.classList.remove('is-back-loading');
      lightboxFlip.disabled = false;
    }

    function getTriggerData(trigger) {
      var cardImages = getCardImages(trigger);

      return {
        src: trigger.getAttribute('data-large-image'),
        alt: trigger.getAttribute('data-image-alt'),
        title: trigger.getAttribute('data-product-title'),
        url: trigger.getAttribute('data-product-url'),
        frontImage: trigger.getAttribute('data-front-image'),
        backImage: trigger.getAttribute('data-back-image'),
        frontThumbnail: trigger.getAttribute('data-front-thumbnail'),
        backThumbnail: trigger.getAttribute('data-back-thumbnail'),
        cardFrontImage: cardImages.front,
        cardBackImage: cardImages.back
      };
    }

    function loadProgressiveImage(image, options) {
      var token = options.token;
      var sourceImage = options.sourceImage;
      var thumbnailSrc = options.thumbnail || '';
      var largeSrc = options.large || '';
      var alt = options.alt || '';

      var placeholder = createImagePlaceholder(sourceImage, image);

      function showImage(src) {
        if (!src) return Promise.resolve(false);

        return preloadImage(src).then(function (success) {
          if (!success || token !== flipToken) return false;
          if (!lightbox.classList.contains('is-active')) return false;

          image.src = src;

          return image.decode().then(function () {
            if (token !== flipToken) return false;

            image.style.visibility = 'visible';

            if (placeholder && placeholder.parentNode) {
              placeholder.remove();
              placeholder = null;
            }

            return true;
          }).catch(function () {
            return false;
          });
        });
      }

      if (thumbnailSrc) {
        showImage(thumbnailSrc).then(function () {
          if (largeSrc && normalizeUrl(largeSrc) !== normalizeUrl(thumbnailSrc)) {
            showImage(largeSrc);
          }
        });
      } else {
        showImage(largeSrc);
      }
    }
    function openLightbox(
      src,
      alt,
      title,
      url,
      frontImage,
      backImage,
      frontThumbnail,
      backThumbnail,
      cardFrontImage,
      cardBackImage
    ) {
      var frontSrc = frontImage || src;
      var backSrc = backImage || src || frontSrc;

      if (!frontSrc) return;

      var currentToken = ++flipToken;
      var imageAlt = alt || title || '';

      window.clearTimeout(closeTimer);

      resetFlipState();

      lightbox.classList.add('is-loading');
      lightbox.classList.remove('is-loaded');

      if (lightboxTitle) {
        lightboxTitle.textContent = title || '';
      }

      if (lightboxOpen) {
        lightboxOpen.href = url || '#';
        lightboxOpen.setAttribute(
          'aria-label',
          title ? 'Open ' + title : 'Open product'
        );
      }

      // Set images before making the lightbox visible
      loadProgressiveImage(lightboxFrontImage, {
        token: currentToken,
        sourceImage: cardFrontImage,
        thumbnail: frontThumbnail,
        large: frontSrc,
        alt: imageAlt
      });

      loadProgressiveImage(lightboxBackImage, {
        token: currentToken,
        sourceImage: cardBackImage,
        thumbnail: backThumbnail,
        large: backSrc,
        alt: imageAlt
      });

      lightbox.removeAttribute('hidden');

      requestAnimationFrame(function () {
        if (currentToken !== flipToken) return;

        lightbox.classList.add('is-active');
        lightbox.classList.remove('is-loading');
        lightbox.classList.add('is-loaded');
      });

      setScrollLock(true);
    }

    function closeLightbox() {
      flipToken++;

      lightbox.classList.remove('is-active');
      lightbox.classList.remove('is-loading');
      lightbox.classList.remove('is-loaded');
      lightbox.classList.remove('is-back-loading');

      resetFlipState();
      setScrollLock(false);

      window.clearTimeout(closeTimer);

      closeTimer = window.setTimeout(function () {
        if (lightbox.classList.contains('is-active')) return;

        lightbox.setAttribute('hidden', 'hidden');

        lightboxFrontImage.removeAttribute('src');
        lightboxFrontImage.alt = '';

        lightboxBackImage.removeAttribute('src');
        lightboxBackImage.alt = '';

        lightboxFlip.disabled = false;
      }, 260);
    }

    function preloadTriggerImages(trigger) {
      if (!trigger) return;

      var data = getTriggerData(trigger);

      // Prepare correct front and back previews early
      if (data.frontThumbnail) {
        preloadImage(data.frontThumbnail);
      }

      if (data.backThumbnail) {
        preloadImage(data.backThumbnail);
      }

      // Start HD front image loading in advance
      if (data.frontImage || data.src) {
        preloadImage(data.frontImage || data.src);
      }
    }

    section.addEventListener('click', function (event) {
      var openButton = event.target.closest('.custom-gallery-card__open');
      if (openButton) return;

      var imageButton = event.target.closest('[data-gallery-flip-trigger]');
      if (!imageButton || !section.contains(imageButton)) return;

      event.preventDefault();
      event.stopPropagation();

      var data = getTriggerData(imageButton);

      openLightbox(
        data.src,
        data.alt,
        data.title,
        data.url,
        data.frontImage,
        data.backImage,
        data.frontThumbnail,
        data.backThumbnail,
        data.cardFrontImage,
        data.cardBackImage
      );
    });

    section.addEventListener('pointerover', function (event) {
      var trigger = event.target.closest('[data-gallery-flip-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      preloadTriggerImages(trigger);
    }, { passive: true });

    section.addEventListener('focusin', function (event) {
      var trigger = event.target.closest('[data-gallery-flip-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      preloadTriggerImages(trigger);
    });

    section.addEventListener('touchstart', function (event) {
      var trigger = event.target.closest('[data-gallery-flip-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      preloadTriggerImages(trigger);
    }, { passive: true });

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeLightbox();
      });
    }

    // Flip instantly, independent of image loading
    lightboxFlip.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (!lightbox.classList.contains('is-active')) return;

      var isFlipped = lightboxFlip.classList.toggle('is-flipped');

      lightboxFlip.setAttribute(
        'aria-pressed',
        isFlipped ? 'true' : 'false'
      );
    });

    lightboxFlip.addEventListener('mouseenter', function () {
      lightboxFlip.classList.remove('is-pointer-out');
    });

    lightboxFlip.addEventListener('mousemove', function (event) {
      var rect = lightboxFlip.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      lightboxFlip.style.setProperty('--flip-label-x', x + 'px');
      lightboxFlip.style.setProperty('--flip-label-y', y + 'px');

      lightboxFlip.classList.remove('is-pointer-out');
    });

    lightboxFlip.addEventListener('mouseleave', function () {
      lightboxFlip.classList.add('is-pointer-out');
    });

    lightbox.addEventListener('click', function (event) {
      if (!lightbox.classList.contains('is-active')) return;

      var clickedFlip = event.target.closest('[data-gallery-flip-button]');
      var clickedOpenButton = event.target.closest('[data-gallery-flip-open]');
      var clickedCloseButton = event.target.closest('[data-gallery-flip-close]');

      if (clickedFlip || clickedOpenButton || clickedCloseButton) return;

      closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-active')) {
        closeLightbox();
      }
    });
  };
})();